export default __webpack_public_path__ + "static/media/circuit_board.2229796b.jpg";